<template>
  <form class="row" @submit.prevent="onSubmit">
    <div class="box-bullets">
      <div class="bullet-diver">&nbsp;</div>
      <ul class="bullets">
        <li class="bullet-item" @click="btnNextStep(1)"><span class="bullet" :class="{'active': stepSelected == 1, 'completed': isCompletedStep1}">1</span></li>
        <li class="bullet-item" @click="btnNextStep(2)"><span class="bullet" :class="{'active': stepSelected == 2, 'completed': isCompletedStep2}">2</span></li>
        <li class="bullet-item" @click="btnNextStep(3)"><span class="bullet" :class="{'active': stepSelected == 3, 'completed': isCompletedStep3}">3</span></li>
      </ul>
    </div>
    <!-- PASSO 1 -->
    <div class="medium-12 columns" v-if="stepSelected === 1">
      <label :class="{ error: $v.name.$error }">
        {{ $t('CADENCIAS.FORM.LABEL_NAME') }}
        <input
          v-model.trim="name"
          type="text"
          name="name"
          :placeholder="
            $t('CADENCIAS.FORM.PLACEHOLDER_NAME')
          "
          @input="$v.name.$touch"
        />
        <span v-if="$v.name.$error" class="message">
          {{ $t('CADENCIAS.FORM.ERROR_NAME') }}
        </span>
      </label>

      <label :class="{ error: $v.description.$error }">
        {{ $t('CADENCIAS.FORM.LABEL_DESCRIPTION') }}
        <input
          v-model.trim="description"
          type="text"
          name="description"
          :placeholder="
            $t('CADENCIAS.FORM.PLACEHOLDER_DESCRIPTION')
          "
          @input="$v.description.$touch"
        />
        <span v-if="$v.description.$error" class="message">
          {{ $t('CADENCIAS.FORM.ERROR_DESCRIPTION') }}
        </span>
      </label>
    </div>
    <!-- PASSO 2 -->
    <div class="medium-12 columns" v-if="stepSelected === 2">
      <label :class="{ error: $v.period.$error }">
        {{ $t('CADENCIAS.FORM.LABEL_PERIOD') }}
        <multiselect
            v-model="period"
            track-by="id"
            label="name"
            :placeholder="$t('FORMS.MULTISELECT.SELECT')"
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :max-height="160"
            :options="periods"
          />
        <span v-if="$v.period.$error" class="message">
          {{ $t('CADENCIAS.FORM.ERROR_PERIOD') }}
        </span>
      </label>
      <div v-if="period">
        <label :class="{ error: $v.rule_cron.$error }" v-if="period.id === -1">
          {{ $t('CADENCIAS.FORM.LABEL_RULE_CRON') }}
          <input
            v-model.trim="rule_cron"
            type="text"
            name="rule_cron"
            :placeholder="
              $t('CADENCIAS.FORM.PLACEHOLDER_RULE_CRON')
            "
            @input="$v.rule_cron.$touch"
          />
          <span v-if="$v.rule_cron.$error" class="message">
            {{ $t('CADENCIAS.FORM.ERROR_RULE_CRON') }}
          </span>
        </label>
        <div v-else>
          <label>
            {{ $t('CADENCIAS.FORM.LABEL_DAYS_WEEK') }}
          </label>
          <div class="week">
            <button v-for="item in week" 
              :title="item.name"
              @click.prevent="addDayWeek(item.id)"
              :class="{ inactive: !days_week.includes(item.id) }"
              class="button ml-1"
              type="button"
            >
              {{ item.sigla }}
            </button>
          </div>
          <label v-if="$v.days_week.$error" :class="{ error: $v.days_week.$error }">
            <span class="message">
              {{ $t('CADENCIAS.FORM.ERROR_DAYS_WEEK') }}
            </span>
          </label>

          <label :class="{ error: ($v.hour_start.$error || $v.hour_end.$error) }">
            {{ $t('CADENCIAS.FORM.LABEL_HOUR') }}
            <div class="flex-container times align-middle">
              <span>{{ $t('CADENCIAS.FORM.LABEL_HOUR_FROM') }}:</span>
              <input
                class="time"
                v-model.trim="hour_start"
                name="hour_start"
                @keydown="checkDigit"
              />
              <span>{{ $t('CADENCIAS.FORM.LABEL_HOUR_TO') }}:</span>
              <input
                class="time"
                v-model.trim="hour_end"
                name="hour_end"
                @keydown="checkDigit"
              />
            </div>
            <span v-if="($v.hour_start.$error || $v.hour_end.$error)" class="message">
              {{ $t('CADENCIAS.FORM.ERROR_HOUR') }}
            </span>
          </label>
        </div>
      </div>
    </div>
    <!-- PASSO 3 -->
    <div class="medium-12 columns" v-if="stepSelected === 3">
      <label :class="{ error: $v.typebot.$error }">
        {{ $t('CADENCIAS.FORM.LABEL_TYPEBOT') }}
        <input
          v-model.trim="typebot"
          type="text"
          name="typebot"
          :placeholder="
            $t('CADENCIAS.FORM.PLACEHOLDER_TYPEBOT')
          "
          @input="$v.typebot.$touch"
        />
        <span v-if="$v.typebot.$error" class="message">
          {{ $t('CADENCIAS.FORM.ERROR_TYPEBOT') }}
        </span>
      </label>
      <label>
        {{ $t('CADENCIAS.FORM.DESC_TYPEBOT') }}
        <img src="/assets/images/dashboard/cadencia/typebot.png" :alt="$t('CADENCIAS.FORM.LABEL_TYPEBOT')"/>
      </label>
    </div>

    <div class="modal-footer footer-actions">
      <div class="medium-12 columns box-actions">
        <woot-button 
          class="button clear" 
          @click.prevent="btnPreviousStep"
          v-if="stepSelected > 1"
        >
          {{$t('CADENCIAS.FORM.BTN_PREV')}}
        </woot-button>
        <woot-button 
          class="button clear" 
          @click.prevent="$emit('cancel')"
          v-else
        >
          {{$t('CADENCIAS.FORM.BTN_CLOSE')}}
        </woot-button>

        <!-- Btn de Ação -->
        <woot-button 
          @click.prevent="btnNextStep(null)" 
          v-if="showBtnNextStep"
        >
          {{$t('CADENCIAS.FORM.BTN_NEXT')}}
        </woot-button>
        <woot-button
          :disabled="isValid || isSubmitting"
          :is-loading="isSubmitting"
          v-else
        >
          {{$t('CADENCIAS.FORM.BTN_SUBMIT')}}
        </woot-button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';

const periods = [
  { id: 5, name: 'A cada 5 minutos', cron: "*/5" },
  { id: 10, name: 'A cada 10 minutos', cron: "*/10" },
  { id: 15, name: 'A cada 15 minutos', cron: "*/15" },
  { id: 30, name: 'A cada 30 minutos', cron: "*/30" },
  { id: 60, name: 'A cada 1 hora', cron: "*/59" },
  { id: -1, name: 'Personalizar', cron: null },
];

const week = [
    { id: 1, name: 'Domingo', sigla: 'D' },
    { id: 2, name: 'Segunda', sigla: 'S' },
    { id: 3, name: 'Terça', sigla: 'T' },
    { id: 4, name: 'Quarta', sigla: 'Q' },
    { id: 5, name: 'Quinta', sigla: 'Q' },
    { id: 6, name: 'Sexta', sigla: 'S' },
    { id: 7, name: 'Sábado', sigla: 'S' },
  ];

const checkHourValidate = (value) => (value < 1 || value > 23) ? false : true;

export default {
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stepSelected: null,
      periods,
      week,
      name: this.value.name || '',
      description: this.value.description || '',
      period: periods.find(item => item.id === 15),
      rule_cron: this.value.rule_cron || null,
      days_week: [],
      hour_start: null,
      hour_end: null,
      typebot: this.value.typebot || null,
      active: this.value.active || true,
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(255),
    },
    description: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(255),
    },
    period: {
      required,
    },
    rule_cron: {
      required,
    },
    days_week: {
      required,
    },
    hour_start: {
      required,
      numeric,
      checkHourValidate,
      checkHourStart(value) {
        if (value > Number(this.hour_end)) {
          return false;
        }
        return true;
      }
    },
    hour_end: {
      required,
      numeric,
      checkHourValidate,
      checkHourEnd(value) {
        if (value < Number(this.hour_start)) {
          return false;
        }
        return true;
      }
    },
    typebot: {
      required,
      minLength: minLength(3),
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    showBtnNextStep() {
      return (!this.stepSelected || this.stepSelected < 3);
    },
    isCompletedStep1() {
      return (this.name && this.stepSelected > 1);
    },
    isCompletedStep2() {
      return (this.stepSelected > 2 && this.isCompletedStep1);
    },
    isCompletedStep3() {
      return (this.stepSelected > 3 && this.isCompletedStep2);
    },
    isValid() {
      if (this.period && this.period.id === -1) {
        return (
          this.$v.name.$invalid &&
          this.$v.description.$invalid &&
          this.$v.rule_cron.$invalid &&
          this.$v.typebot.$invalid
        );
      }

      return this.$v.$invalid;
    }
  },
  watch: {
    period(value) {
      if (value?.id !== -1) this.updateRuleCron();
    },
    days_week() {
      this.updateRuleCron();
    },
    hour_start() {
      this.updateRuleCron();
    },
    hour_end() {
      this.updateRuleCron();
    },
  },
  created() {
    this.stepSelected = 1; // Inicia no primeiro passo
    if (this.rule_cron) {
      const { time, diasDaSemana, horarioInicial, horarioFinal } = this.parseCron(this.rule_cron);
      this.period = periods.find(item => item.cron === time) || periods.find(item => item.id === -1);
      this.days_week = diasDaSemana;
      this.hour_start = horarioInicial;
      this.hour_end = horarioFinal;
    }
  },
  methods: {
    updateRuleCron() {
      // Quando for Cron personalizado não atualiza a regra
      if (!this.period || this.period.id === -1) return;
      // Monta a regra do cron com base nos campos selecionados: Dias da Semana, Horário Inicial e Final
      this.rule_cron = this.createCron(this.period.cron, this.days_week, this.hour_start, this.hour_end);
    },
    btnPreviousStep() {
      if (this.stepSelected === 1) {
        this.$emit('cancel');
      } else {
        this.stepSelected -= 1;
      }
    },
    btnNextStep(step = null) {
      switch(this.stepSelected) {
        case 1:
          this.$v.name.$touch();
          this.$v.description.$touch();
          if (this.$v.name.$invalid || this.$v.description.$invalid) return;
          break;
        case 2:
          this.$v.period.$touch();
          this.$v.rule_cron.$touch();
          this.$v.days_week.$touch();
          this.$v.hour_start.$touch();
          this.$v.hour_end.$touch();

          if (this.$v.period.$invalid) return;
          if (this.period && this.period.id === -1 && this.$v.rule_cron.$invalid) return;
          if (this.period && this.period.id !== -1 && this.$v.days_week.$invalid) return;
          if (this.period && this.period.id !== -1 && (this.$v.hour_start.$invalid || this.$v.hour_end.$invalid)) return;
          break;
      }
      if (step) {
        this.stepSelected = step;
      } else {
        this.stepSelected += 1;
      }
    },
    addDayWeek(id) {
      if (this.days_week.includes(id)) {
        this.days_week = this.days_week.filter(item => item !== id);
      } else {
        this.days_week.push(id);
      }
    },
    createCron(time, diasDaSemana, horarioInicial, horarioFinal) {
      const minutos = time || "*";
      const horas = horarioInicial !== null && horarioFinal !== null 
          ? `${horarioInicial}-${horarioFinal}` 
          : "*";
      const diasSemana = diasDaSemana.length > 0 
          ? diasDaSemana.join(",") 
          : "*";

      return `${minutos} ${horas} * * ${diasSemana}`;
    },
    parseCron(cron) {
      const [time, hours, , , days] = cron.split(" ");
    
      const horarioInicial = hours.includes("-") ? parseInt(hours.split("-")[0]) : "*";
      const horarioFinal = hours.includes("-") ? parseInt(hours.split("-")[1]) : "*";
      const diasDaSemana = days !== "*" ? days.split(",").map(Number) : [];
      
      return {
          time,
          diasDaSemana,
          horarioInicial,
          horarioFinal
      };
    },
    checkDigit(event) {
      if (event.key.length === 1 && isNaN(Number(event.key))) {
        event.preventDefault();
      }
    },
    onSubmit() {
      this.$v.typebot.$touch();
      if (this.$v.typebot.$invalid) return;

      this.$emit('submit', {
        name: this.name,
        description: this.description,
        rule_cron: this.rule_cron,
        typebot: this.typebot,
        active: this.active,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box-bullets {
  width: 100%;
  margin: 0 10% 20px;
  position: relative;
  .bullets {
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    .bullet-item {
      z-index: 1;
      cursor: pointer;
      .bullet {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid #1b387c;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #1b387c;
        &.active {
          background: #1b387c;
          color: #fff;
        }
        &.completed {
          background: #27ae60;
          border: 1px solid #27ae60;
          color: #fff;
        }
      }
    }
  }
  .bullet-diver {
    width: 100%;
    height: 1px;
    background: #1b387c;
    margin-top: 17px;
    position: absolute;
    top: 0;
  }
}
.footer-actions {
  display: flex;
  flex: 1;
  .box-actions {
    display: flex;
    justify-content: space-between;
  }
}
.input-range {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.input-number {
  width: 60px;
  height: 100%;
  margin: 0;
  margin-left: 10px;
}
.textlong {
  height: 120px;
}
.button {
  &.inactive {
    background: #f1f1f1;
    color: #999;
    cursor: pointer;
  }
}
.times {
  input.time {
    width: 50px;
    height: 30px;
    margin: 0 10px;
  }
}
.week,.times {
  margin-bottom: 1.6rem;
}
</style>